import React from 'react';
import { Link, Outlet, useLocation } from 'react-router-dom';
import { Container, Tabs, Tab, useMediaQuery } from '@mui/material';
import { useTheme } from '@mui/material/styles';

function AdminPage() {
  const location = useLocation();
  const theme = useTheme();
  // Five fixed tabs need ~450px; a phone has ~343px after gutters, so the
  // fixed, centered layout clips the first and last tab with no way to reach
  // them. Below the sm breakpoint the bar scrolls instead.
  const isPhone = useMediaQuery(theme.breakpoints.down('sm'));

  const tabNameToIndex = {
    '/admin/games': 0,
    '/admin/scoring': 1,
    '/admin/teams': 2,
    '/admin/api-usage': 3,
    '/admin/users': 4,
  };

  const [value, setValue] = React.useState(tabNameToIndex[location.pathname] ?? false);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  React.useEffect(() => {
    setValue(tabNameToIndex[location.pathname] ?? false);
  }, [location.pathname]);

  return (
    // Each admin screen brings its own Container (and gutters), so this outer
    // one only constrains width. Its gutters would otherwise double up.
    <Container disableGutters>
      <Tabs
        value={value}
        onChange={handleChange}
        variant={isPhone ? 'scrollable' : 'standard'}
        centered={!isPhone}
        scrollButtons="auto"
        allowScrollButtonsMobile
      >
        {/* The query string carries the working season/week (see useAdminWeek),
            so the week picked on Games is the week Scoring opens on. */}
        <Tab label="Games" component={Link} to={{ pathname: '/admin/games', search: location.search }} />
        <Tab label="Scoring" component={Link} to={{ pathname: '/admin/scoring', search: location.search }} />
        <Tab label="Teams" component={Link} to={{ pathname: '/admin/teams', search: location.search }} />
        <Tab label="API Usage" component={Link} to={{ pathname: '/admin/api-usage', search: location.search }} />
        <Tab label="Users" component={Link} to={{ pathname: '/admin/users', search: location.search }} />
      </Tabs>
      <Outlet />
    </Container>
  );
}

export default AdminPage;
